export default "__VITE_ASSET__7c221ab4__"